export default __webpack_public_path__ + "static/media/loans.25accb69.png";